import React, { useState, useEffect } from 'react';
import './About.css'
import About_Img from '../images/about.jpg';


const About = ({ toggleTheme }) => {

  // ✅ Put useEffect HERE — inside the component
    useEffect(() => {
      const boxes = document.querySelectorAll(".even-box");
  
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add("scrolled");
            } else {
              entry.target.classList.remove("scrolled");
            }
          });
        },
        {
          threshold: 0.1,
        }
      );
  
      boxes.forEach(box => observer.observe(box));
  
      return () => {
        boxes.forEach(box => observer.unobserve(box));
      };
    }, []);
  
  return (
    <div className="mt-3">
      {/* Hero Section Starts */}
      <div className="about-hero d-flex align-items-center">
        <div className="about-hero-inner container">
          <div className="hero-content">
            <h2 className="hero-title title display-3">About Us</h2>
            <p>Home / About Us</p>
          </div>
        </div>
      </div>
      {/* Hero Section Ends */}
      {/* <!-- about us section start  --> */}
      <section className="container-fluid py-5 bg-light-gray">
        <div className="container">
          <div className="row py-lg-5">
            <div className="col-lg-5">
              <h5 className="mb-3 title fw-bold fs-4 letter-spacing-3">WHO WE ARE</h5>
              <h1 className="display-4">We're A Team Of <br /><span className="title letter-spacing-3">PER A CAUSE.</span> </h1>
              <p className="fs-5">We are a team of WordPress Developers, Webflow Developers, and UI/UX Designers. Our focus is on crafting high-performance websites with exceptional functionality and design. Every project is built to inspire and leave a lasting <span className="title">"IMPRESSION".</span> </p>
              <p className="fs-5">We specialize in SEO, social media marketing, and paid advertising, ensuring your brand gains maximum visibility and engagement.</p>
            </div>
            <div className="col-lg-7 d-flex align-items-center justify-content-center">
              <img className="img-fluid rounded-4" src={About_Img} alt="about-img" />
            </div>
          </div>
        </div>
      </section>
      {/* <!-- about us section end  --> */}
      {/* <!-- numbers boxes start --> */}

      <section class="container-fluid py-3 fade-box-main">
        <div class="container">
          <div class="row align-items-center justify-content-start my-5">
            <div class="col-lg-8 even-box">
              <div class="fade-box position-relative">
                <div class="number-box">
                  <h1 class="fade-number">01</h1>
                </div>
                <div class="number-text-box position-absolute">
                  <h2 class="title display-5">Strategic Planning & Research​</h2>
                  <p class="text-white fs-5">We start by understanding your business, audience, and goals. Our strategic approach ensures that whether it’s website development, branding, SEO, or social media marketing, every step is planned for success.</p>
                </div>
              </div>
            </div>

          </div>
          <div class="row align-items-center justify-content-center mt-sm-16">
            <div class="col-lg-8 even-box">
              <div class="fade-box position-relative">
                <div class="number-box">
                  <h1 class="fade-number text-center">02</h1>
                </div>
                <div class="number-text-box position-absolute text-center">
                  <h2 class="title display-5">Design, Development & Digital Solutions​</h2>
                  <p class="text-white fs-5">From WordPress and Webflow websites to logos, brand identities, and digital assets, we craft high-quality solutions that are both visually stunning and performance-driven. Our team delivers fast turnarounds without compromising on creativity or functionality.</p>
                </div>
              </div>
            </div>

          </div>
          <div class="row align-items-center justify-content-end mt-sm-12">
            <div class="col-lg-8 even-box">
              <div class="fade-box position-relative">
                <div class="number-box">
                  <h1 class="fade-number text-end">03</h1>
                </div>
                <div class="number-text-box position-absolute text-end">
                  <h2 class="title display-5">Marketing, Growth & Optimization​​</h2>
                  <p class="text-white fs-5">We go beyond just building websites—we help businesses attract, engage, and convert audiences. With SEO, paid advertising, content marketing, and social media strategies, we drive measurable results, boosting brand visibility and online growth.</p>
                </div>
              </div>
            </div>

          </div>

        </div>

      </section>

      {/* <!-- numbers boxes end --> */}
    </div>
  );
};

export default About;
